import InfoHint from '../../components/InfoHint'

/** A card title with its one-line explanation behind an "i", not under it. */
export default function TitleWithHint({ title, hint }) {
  return (
    <>
      {title}
      <InfoHint content={<bdi>{hint}</bdi>} />
    </>
  )
}
